import React from 'react';
import { IconButton } from '@mui/material';
import { IconArrowLeftSolid } from '@roku-web-ui/rds-icons';
import { useNavigate } from '@tanstack/react-router';
import { colors } from '@roku-web-ui/rds-theme';

import { Tooltip } from 'components/common/Tooltip';
import { useAspenLogger } from 'hooks/useAspenLogger';

interface PreviousEventProps {
  previousEventId: string;
  currentEventId: string;
}

export const PreviousEvent = ({ previousEventId, currentEventId }: PreviousEventProps) => {
  const navigate = useNavigate();
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip title="Previous event" placement="top">
      <IconButton
        aria-label="previous-event"
        data-testid="button-previous-event"
        onClick={() => {
          logAspenEvent({
            log_id: 'iot.web.event.interaction',
            payload: {
              event_id: currentEventId,
              target_event_id: previousEventId,
              interaction: 'previous_event',
            },
          });

          navigate({
            to: '/events',
            search: {
              eventId: previousEventId,
            },
          });
        }}
        sx={{
          '&.MuiIconButton-root': {
            padding: '0', // Override RDS padding
          },
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        <IconArrowLeftSolid sx={{ color: colors.grey[400] }} />
      </IconButton>
    </Tooltip>
  );
};
